exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swal2-container{z-index:9000!important}.setupSelection .el-select-dropdown{min-width:100%!important;max-width:none!important;box-sizing:border-box}.VendorSelect .el-select-dropdown__list{max-height:400px}#VQReqDocs .el-upload-list--text{overflow-x:hidden;max-width:300px}.chkAgree .el-checkbox__inner{align-self:start}.chkAgree>.el-checkbox__label{display:inline-flex;white-space:normal!important}", ""]);

// exports
